<script setup lang="ts">
/**
 * Directors' Resolution (Appoint Director) — B32101, 회사 단위 1부. 원본 템플릿(PRS003) 문안 재현.
 *   선임 이사 목록([[if new_directors]])은 Form 45 의 선임 이사 이름·NRIC 에서 도출. 서명 = 현직 이사([[Signers]]).
 */
import { computed, inject } from 'vue';
import CddVarField from '@/features/startTask/my_preset/sg/aura/agm/cdd/CddVarField.vue';
import AgmSigners from '@/features/startTask/my_preset/sg/aura/agm/cdd/AgmSigners.vue';
import '@/features/startTask/my_preset/sg/aura/agm/docs/agmDoc.css';

interface Row { name: string; nric: string; label: string }
const people = inject<any>('adPeople', null);
const appointees = computed<Row[]>(() => (people?.value as Row[]) || []);
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head" style="text-align:center">
      <div class="doc-company"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div>(Company Registration No.: <CddVarField field-key="company_registration_no" label="UEN" />)</div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the “Company”)</div>
    </div>

    <p class="sec-title" style="text-align:center;margin-top:12px">DIRECTORS’ RESOLUTION(S) IN WRITING<br />PASSED PURSUANT TO THE COMPANY’S CONSTITUTION</p>

    <p class="sec-title">1. APPOINTMENT OF DIRECTOR(S)</p>
    <p class="doc-p">RESOLVED THAT:-</p>
    <p class="doc-p">Subject to each of the following person(s) having signed the Form 45 (Consent to Act as Director and Statement of Non-Disqualification to Act as Director), the said person(s) be and is/are hereby appointed as Director(s) of the Company with effect from the date of their respective consent to act:</p>
    <div v-if="appointees.length" class="list">
      <div v-for="(d, i) in appointees" :key="i" class="list-row">{{ d.name }} ({{ d.label }}: {{ d.nric }})</div>
    </div>
    <div v-else class="list-empty">(enter the appointed director(s) in the Form 45 stage)</div>

    <p class="sec-title">2. LODGEMENT OF NOTICE(S) TO THE ACCOUNTING AND CORPORATE REGULATORY AUTHORITY</p>
    <p class="doc-p">RESOLVED THAT:-</p>
    <p class="doc-p"><CddVarField field-key="secretary_firm_name" label="Secretary firm (lodger)" /> be hereby authorised to lodge the requisite notice(s) on the appointment of Director(s), for and on behalf of the Company with the Accounting and Corporate Regulatory Authority and to make all necessary entries in the corporate records of the Company.</p>

    <p class="sec-title">3. DECLARATIONS OF DIRECTOR’S INTEREST(S) IN CONTRACT(S)</p>
    <p class="doc-p">RESOLVED THAT:-</p>
    <p class="doc-p">The declarations of interest(s) pursuant to Section 156 of the Companies Act 1967 by the said person(s) as attached hereto be recorded and henceforth he/she/they is/are deemed to be regarded as interested in any contract which the Company may make with the corporations mentioned therein.</p>

    <p class="doc-p" style="margin-top:12px">Date: <CddVarField field-key="resolution_date" label="Resolution date" /></p>
    <p class="doc-p"><b>BOARD OF DIRECTORS</b></p>
    <AgmSigners var-key="dr_Signers" board-label="Directors" />
  </div>
</template>

<style scoped>
.doc-company { font-weight: 800; font-size: 13.5px; }
.list { margin: 4px 0 4px 8px; }
.list-row { padding: 2px 0; font-weight: 600; color: #10305c; }
.list-empty { margin: 4px 0 4px 8px; font-size: 11px; color: #b98900; font-style: italic; }
</style>
